<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Location Check</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>

		<b-container>
			<b-row class="mt-4">
				<b-col cols="auto" sm="5">
					<b-card>
						<div >
							<b-row class="justify-content-center">
								<b-form @submit="submitSearch">
									<b-form-group
										label-for="imsi"
										:state="!searchDisabled"
										invalid-feedback="Please enter a valid IMSI."
										class="align-items-center"
									>
										<b-row>
											<b-col cols="4">
												<p :class="infoFieldsClass">Full IMSI:</p>
											</b-col>
											<b-col>
												<b-form-input
													id="imsi"
													v-model="imsiSearch"
													placeholder="Enter IMSI"
													:state="!searchDisabled"
													type="number"
													size="sm"
												>
												</b-form-input>
											</b-col>
										</b-row>
										<b-row>
											<b-col cols="4">
												<p :class="infoFieldsClass">Row Limit:</p>
											</b-col>
											<b-col>
												<b-form-select
													id="row-limit"
													v-model="rowLimit"
													:options="rowLimitOptions"
													selected="5"
													size="sm"
													disabled-field="notEnabled"
												>
												</b-form-select>
											</b-col>
										</b-row>
										<b-row>
											<b-col class="w-100 justify-content-end">
												<b-button
													v-if="loadingStatus"
													block
													class="mt-2"
													variant="primary"
													size="sm"
													type="button"
													disabled
												>
													<b-spinner variant="light" label="Loading..."></b-spinner>
													Loading...
												</b-button>
												<b-button
													v-else
													block
													class="mt-2"
													variant="primary"
													size="sm"
													:loadingStatus="loadingStatus"
													:disabled="searchDisabled || loadingStatus || chartLoading"
													type="submit"
												>
													Search <i class="fa fa-search"></i>
												</b-button>
											</b-col>
										</b-row>
									</b-form-group>
								</b-form>
							</b-row>
						</div>
						<hr clas="m-0 p-0">
						<b-card-body>
							<b-row class="justify-content-between">
								<b-col cols="5" sm="6">
									<p :class="infoFieldsClass">IMSI:</p>
								</b-col>
								<b-col>{{ imsi }}</b-col>
							</b-row>
							<b-row class="justify-content-between">
								<b-col cols="5" sm="6">
									<p :class="infoFieldsClass">Phone Brand:</p>
								</b-col>
								<b-col>{{ phoneBrand }}</b-col>
							</b-row>
							<b-row>
								<b-col cols="5" sm="6">
									<p :class="infoFieldsClass">Phone Model:</p>
								</b-col>
								<b-col>{{ phoneModel }}</b-col>
							</b-row>
							<b-row>
								<b-col cols="5" sm="6">
									<p :class="infoFieldsClass">Connection Type:</p>
								</b-col>
								<b-col>{{ connectionType }}</b-col>
							</b-row>
							<b-row>
								<b-col cols="5" sm="6">
									<p :class="infoFieldsClass">Network:</p>
								</b-col>
								<b-col>{{ network }}</b-col>
							</b-row>
							<b-row>
								<b-col cols="5" sm="6">
									<p :class="infoFieldsClass">3G VLR:</p>
								</b-col>
								<b-col>{{ vlrType }}</b-col>
							</b-row>
							<b-row>
								<b-col cols="5" sm="6">
									<p :class="infoFieldsClass">LTE MME:</p>
								</b-col>
								<b-col>{{ mmeType }}</b-col>
							</b-row>
						</b-card-body>
					</b-card>
				</b-col>
				<b-col class="bg-light p-2" style="height: 610px">
					<!-- Data Volume By Region Card (map) -->
					<div class="text-center w-100" v-if="loadingStatus">
						<p v-if="loadingStatus">Searching for location data on IMSI {{ imsiSearch }}</p>
						<b-icon
							icon="three-dots"
							class="text-center"
							animation="cylon"
							font-scale="4"
							v-if="loadingStatus"
						></b-icon>
					</div>
					<div id="map" class="map-canvas" style="height: 100%">
					</div>
				</b-col>
			</b-row>
			<b-row class="mt-4">
				<b-col cols="auto">
					<b-card>
						<!-- Time period form -->
						<b-form @submit="updateChart($event)">
							<label for="chart-date" :class="infoFieldsClass">Full IMSI</label>
							<b-form-input id="chart-date" placeholder="Enter IMSI" :state="chartImsiState" v-model="chartImsi" size="sm" type="number" />
							<label for="chartInterval" :class="infoFieldsClass">Select time Interval</label>
							<b-select
								id="chartInterval"
								size="sm"
								v-model="chartInterval"
								:options="chartIntervalOptions"
							>
							</b-select>
							<div v-if="chartInterval === 'Hourly'" style="padding: 5px; margin-top: 15px">
								<label for="chart-date" :class="infoFieldsClass">Select Day</label>
								<b-form-input id="chart-date" v-model="chartDate" size="sm" type="date" disabled />
								<label for="start-time" :class="infoFieldsClass">Start Time</label>
								<b-form-input id="start-time" v-model="startTime" size="sm" type="time" />
								<label for="end-time" :class="infoFieldsClass">End Time</label>
								<b-form-input id="end-time" v-model="endTime" size="sm" type="time" />
							</div>
							<div v-if="chartInterval === 'Daily'" style="padding: 5px; margin-top: 15px">
								<label for="daily-date" :class="infoFieldsClass">Select Day</label>
								<b-form-input id="daily-date" v-model="dailyDate" size="sm" type="date" />
							</div>
							<div v-if="chartInterval === 'Weekly'" style="padding: 5px; margin-top: 15px">
								<label for="from-date" :class="infoFieldsClass">Select Day</label>
								<b-form-input id="from-date" v-model="fromDate" size="sm" type="date" />
								<label for="to-date" :class="infoFieldsClass">Select Day</label>
								<b-form-input id="to-date" v-model="toDate" size="sm" type="date" />
							</div>

							<div style="padding: 5px; text-align: right">
								<b-button variant="primary" size="sm" :disabled="!chartImsiState || chartLoading" type="submit"
									>Update Chart</b-button
								>
							</div>
						</b-form>
						<!-- Data Volume Card -->
					</b-card>
				</b-col>
				<b-col>
					<div class="diameter-highchart text-center">
						<div class="text-center w-100">
							<p v-if="chartLoading">Searching for usage data on IMSI {{ imsiSearch }}</p>
							<b-icon
								icon="three-dots"
								class="text-center"
								animation="cylon"
								font-scale="4"
								v-if="chartLoading"
							></b-icon>
							<p v-if="!isChartData && !chartLoading">No chart data to display</p>
						</div>
						<div id="chart" v-if="isChartData">
							<highcharts :options="chartOptions"></highcharts>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import RouteBreadCrumb from "../../../components/Breadcrumb/RouteBreadcrumb";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import configDirective from "@/common/directive/config-directive";
import {Chart} from "highcharts-vue";

import {Loader} from "google-maps";
import initService from "../../../common/api-services/init-service";

export default {
	name: "LocationCheck",
	components: {
		RouteBreadCrumb,
		Highcharts: Chart,
	},
	async mounted() {
		document.title = "Troubleshooting - Location Check";

		const loader = new Loader(configDirective.getGoogleApiKey(), {libraries: ["visualization"]});
		const google = await loader.load();
		this.initializeMap();
		this.noAccess =
            !initService.getUserRoles().includes("Administrator") &&
            !initService.getUserRoles().includes("CARRIER_ADMIN") &&
            !initService.getUserRoles().includes("PORTAL_ADMIN ");

        //don't do anything unless the user has access
        if (this.noAccess) {
          this.$router.push('/home');
        }
	},
	computed: {
		searchDisabled() {
			return !(String(this.imsiSearch).length === 15);
		},
		chartImsiState() {
			return String(this.chartImsi).length === 15;
		},
		isChartData() {
			return this.chartOptions.series.length > 0;
		},
	},
	data() {
		return {
			markerCount: [],
			chart: null,
			chartImsi: "",
			chartInterval: "Hourly",
			chartIntervalOptions: ["Hourly", "Daily", "Weekly"],
			startTime: "00:00",
			endTime: "23:59",
			chartDate: new Date().toISOString().substr(0, 10),
			dailyDate: new Date().toISOString().substr(0, 10),
			toDate: new Date().toISOString().substr(0, 10),
			fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
			chartXLabel: [],
			chartDataVolume: [],
			dataVolumeByPeriodToolTip: null,
			dataVolumeByRegionToolTip: null,
			imsiSearch: "",
			rowLimit: 5,
			rowLimitOptions: [5, 10, 15, 20],
			imsi: "",
			iccid: "",
			msisdn: "",
			phoneBrand: "Unknown",
			phoneModel: "Unknown",
			connectionType: "Unknown",
			network: "Unknown",
			vlrType: "Unknown",
			mmeType: "Unknown",
			loadingStatus: false,
			chartLoading: false,
			isNsim: false,
			isAdminUser: false,
			isPortalAdminUser: false,
			isReadOnlyUser: true, //default setting is readonly
			infoFieldsClass: "text-nowrap font-weight-600 p-0 m-0",

			chartOptions: {
				//      global: {
				//        useUTC: false
				//  },
				tooltip: {
					valueSuffix: " o",
				},
				chart: {
					zoomType: "x",
				},
				title: {
					text: "Usage",
				},
				xAxis: {
					type: "datetime",
				},
				yAxis: {
					title: {
						text: "",
					},
				},
				legend: {
					layout: "vertical",
					align: "right",
					verticalAlign: "middle",
				},
				plotOptions: {
					series: {
						label: {
							connectorAllowed: false,
						},
						marker: {
							enabled: false,
						},
					},
					colors: [
						"#7cb5ec",
						"#434348",
						"#90ed7d",
						"#f7a35c",
						"#8085e9",
						"#f15c80",
						"#e4d354",
						"#2b908f",
						"#f45b5b",
						"#91e8e1",
					],
				},
				series: [],
			},
		};
	},
	methods: {
		async submitSearch(event) {
			event.preventDefault();
			document.getElementById("map").innerHTML = "";
			this.chartOptions.series = [];
			this.markerCount = [];
			this.loadingStatus = true;
			this.resetData();
			this.getImsiData(this.imsiSearch);
			this.getDataVolumeByRegion();
			if (this.chartImsi.length === 0) {
				this.chartImsi = this.imsiSearch;
			}
		},

		async updateChart(event) {
			event.preventDefault();
			this.chartLoading = true;
			this.chartOptions.series = [];
			let start;
			let end;

			switch (this.chartInterval) {
				case "Hourly":
					start = this.chartDate + " " + this.startTime + ":00";
					end = this.chartDate + " " + this.endTime + ":00";
					break;
				case "Daily":
					start = this.dailyDate + " 00:00:00";
					end = this.dailyDate + " 23:59:00";
					break;
				case "Weekly":
					start = this.fromDate + " 00:00:00";
					end = this.toDate + " 23:59:00";
					break;
				default:
					start = this.chartDate + " " + this.startTime + ":00";
					end = this.chartDate + " " + this.endTime + ":00";
			}

			await troubleshootingService.getChartData(this.imsi, start, end).then(response => {
				// console.log("getChartData:", response.message);
				if (!String(response.message).toLowerCase().includes("null")) {
					var data = [];
					var retdata = response.message;

					var browserDate = new Date();
					var timezoneOffset = browserDate.getTimezoneOffset() * 60 * 1000;

					data.push({
						name: "In (octet)",
						data: retdata.map(e => [
							Date.parse(e.acctstoptime) - timezoneOffset,
							parseFloat(e.acctinputoctets),
						]),
					});
					data.push({
						name: "Out (octet)",
						data: retdata.map(e => [
							Date.parse(e.acctstoptime) - timezoneOffset,
							parseFloat(e.acctoutputoctets),
						]),
					});

					this.chartOptions.series = data;
				} else if (String(response.message).toLowerCase().includes("null")) {
					this.$toast.info("No chart data found for the selected time period.");
				}
				this.chartLoading = false;
			});
		},

		async getDataVolumeByRegion() {
			await troubleshootingService.getLocationInfoByImsi(this.imsiSearch, this.rowLimit).then(response => {
				// console.log("getLocationInfoByImsi:", response.message);
				let nullCheck = !String(response.message).toLowerCase().includes("null");
				let errorCheck = !String(response.message).toLowerCase().includes("error");
				let failCheck = !String(response.message).toLowerCase().includes("fail");
				if (nullCheck && errorCheck && failCheck) {
					let info = response.message[0];

					this.imsi = this.imsiSearch;
					this.phoneBrand = info.brand ? info.brand : "Unknown";
					this.phoneModel = info.model ? info.model : "Unknown";
					this.connectionType = info.connectiontype ? info.connectiontype : "Unknown";
					this.network = info.Network ? info.Network : "Unknown";

					this.markerCount = response.message;
				} else {
					this.loadingStatus = false;
					if (!errorCheck || !failCheck) this.$toast.error("Error retrieving location data.");
					else this.$toast.info("No location data found for IMSI " + this.imsiSearch);
				}
				this.initializeMap();
			});
		},

		async initializeMap() {
			let configData = configDirective.getConfigData();
			let bound = new google.maps.LatLngBounds();
			let map_center = configData["site-settings"]["map_center"].split(",");
			let center = new google.maps.LatLng(map_center[0], map_center[1], true);
			let zoom = configData["site-settings"]["map_zoom"] ? configData["site-settings"]["map_zoom"] : 3;

			const map = new google.maps.Map(document.getElementById("map"), {
				center: center,
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
			});

			let isFirst = true;
			if (this.markerCount.length > 0) {
				for (let i = 0; i < this.markerCount.length; i++) {
					let value = this.markerCount[i];
					if (value != null) {
						this.addMarker(value, isFirst, map, bound);
						isFirst = false;
					}
				}
			} else {
				let defaultMarker = {
					lat: map_center[0],
					lon: map_center[1],
					connectiontype: "Default Marker",
				}
				this.addMarker(defaultMarker, false, map, bound);
			}

			// Set map center and zoom to fit all markers
			google.maps.event.addListener(map, "zoom_changed", function () {
				const zoomChangeBoundsListener = google.maps.event.addListener(map, "bounds_changed", function (event) {
					// Initial zoom level check
					if (this.getZoom() > 15 && this.initialZoom == true) {
						// Change max/min zoom here
						this.setZoom(15);
						//map.setZoom(15);
						this.initialZoom = false;
					}
					google.maps.event.removeListener(zoomChangeBoundsListener);
				});
			});
			map.initialZoom = true;
			map.fitBounds(bound);

			this.loadingStatus = false;
		},

		addMarker(param, isfirst, map, bounds) {
			let icon_3green = "https://i.imgur.com/vSpGkBd.png";
			let icon_4green = "https://i.imgur.com/8jLOZnY.png";
			let icon_3yellow = "https://i.imgur.com/SU1eH1v.png";
			let icon_4yellow = "https://i.imgur.com/theJhNx.png";
			let icon_cgreen = "https://i.imgur.com/CM5c7BE.png";
			let icon_cyellow = "https://i.imgur.com/2eE096C.png";
			let sel_icon = "";

			if (param.connectiontype == "3G" && isfirst == true) {
				//green triangle
				sel_icon = icon_3green;
			} else if (param.connectiontype == "3G" && isfirst == false) {
				// yellow triangle
				sel_icon = icon_3yellow;
			} else if (param.connectiontype == "LTE" && isfirst == true) {
				//green square
				sel_icon = icon_4green;
			} else if (param.connectiontype == "LTE" && isfirst == false) {
				// yellow square
				sel_icon = icon_4yellow;
			} else {
				if (isfirst == true) sel_icon = icon_cgreen;
				else sel_icon = icon_cyellow;
			}

			// console.log("param:", param)

			let imsi = this.imsiSearch;
			let authDate = param.authdate ? param.authdate : "NO DATA";
			let connectiontype = param.connectiontype ? param.connectiontype : "Unknown";
			let contentString =
				'<div id="content">' +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Auth Date: </span> ' +
				authDate +
				"</p>" +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">IMSI: </span> ' +
				imsi +
				"</p>" +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Connection Type: </span> ' +
				connectiontype +
				"</p>" +
				"</div>";

			let infowindow = new google.maps.InfoWindow({
				content: contentString,
			});

			let marker = new google.maps.Marker({
				position: {
					lat: parseFloat(param.lat),
					lng: parseFloat(param.lon),
				},

				map: map,
				title: "Point",
				icon: sel_icon,
			});
			marker.addListener("click", function () {
				infowindow.open(map, marker);
			});
			bounds.extend(marker.position);
			map.fitBounds(bounds);
			let markercount = this.markerCount;
			if (markercount[param.connectiontype] == null) markercount[param.connectiontype] = 1;
			else markercount[param.connectiontype] += 1;

			var ct = "";
			for (var i in markercount) {
				ct += i + "(" + markercount[i] + "), ";
			}
		},

		async getImsiData(imsi) {
			await troubleshootingService.getVolatileData(imsi).then(response => {
				// console.log("getVolatileData:", response.message);
				if (!JSON.stringify(response.message).includes("No records found.")) {
					this.vlrType = info.vlrType ? info.vlrType : "Unknown";
					this.mmeType = info.mmeType ? info.mmeType : "Unknown";
				}
			});
		},

		resetData() {
			this.imsi = "";
			this.iccid = "";
			this.phoneBrand = "Unknown";
			this.phoneModel = "Unknown";
			this.connectionType = "Unknown";
			this.network = "Unknown";
			this.vlrType = "Unknown";
			this.mmeType = "Unknown";
			this.markerCount = [];
			this.chartOptions.series = [];
		},
	},
};
</script>

<style scoped>
.diameter-highchart {
	border: 10px solid #dee2e6;
	background-color: #dee2e6;
	min-height: 400px;
}
</style>
